import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { BasicDataResult } from 'src/app/core/services/data-orchestrator';
import { AccountPasswordReset } from '../../models/events/events';
import { EVENTS_FACADE } from 'src/app/core/services/facades';

export interface ResetPasswordAdapterResetPasswordResult {
  email: string;
  password: string;
}

@Injectable()
export class ResetPasswordAdapterService {
  private readonly eventsFacade = inject(EVENTS_FACADE);

  public resetPassword(
    password: string,
    route: ActivatedRouteSnapshot,
  ): Observable<BasicDataResult<ResetPasswordAdapterResetPasswordResult>> {
    const eventData: AccountPasswordReset = {
      emailAddress: route.queryParamMap.get('emailAddress'),
      newPassword: password,
      passwordResetToken: route.queryParamMap.get('passwordResetToken'),
    };

    return this.eventsFacade.sendEventWithResponse({ eventType: 'AccountPasswordReset', jsonData: eventData }).pipe(
      map((result) => {
        if (result && !result.loading && !result.error) {
          return {
            ...result,
            data: {
              email: eventData.emailAddress,
              password,
            },
          };
        }

        return {
          ...result,
          data: null,
        };
      }),
    );
  }

  public canResetPassword(route: ActivatedRouteSnapshot): Observable<boolean> {
    const passwordResetToken = route.queryParamMap.get('passwordResetToken');
    const emailAddress = route.queryParamMap.get('emailAddress');

    return of(!!passwordResetToken && !!emailAddress);
  }
}
